import { render, staticRenderFns } from "./upload-cropper.vue?vue&type=template&id=2c9aaa2a&"
import script from "./upload-cropper.vue?vue&type=script&lang=js&"
export * from "./upload-cropper.vue?vue&type=script&lang=js&"
import style0 from "./upload-cropper.vue?vue&type=style&index=0&id=2c9aaa2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports